export const PHONEMIC_LETTERS_FR = ['P', 'F', 'M', 'L', 'R'];
export const PHONEMIC_LETTERS_EN = ['F', 'A', 'S', 'L', 'P'];
export const SEMANTIC_CATEGORIES = [
    { key: 'animals', labelKey: 'verbal_fluency.categories.animals' },
    { key: 'fruits', labelKey: 'verbal_fluency.categories.fruits' },
    { key: 'professions', labelKey: 'verbal_fluency.categories.professions' },
    { key: 'clothes', labelKey: 'verbal_fluency.categories.clothes' },
    { key: 'sports', labelKey: 'verbal_fluency.categories.sports' },
];
function phonemicLetters(locale) {
    return locale === 'en' ? PHONEMIC_LETTERS_EN : PHONEMIC_LETTERS_FR;
}
/**
 * Sélection déterministe d'un prompt selon (mode, locale, idx).
 * `idx` est typiquement `trialIdx`. Le cycle est modulo banque.
 */
export function pickPrompt(mode, locale, idx) {
    const safeIdx = Math.max(0, Math.floor(idx));
    if (mode === 'phonemic') {
        const letters = phonemicLetters(locale);
        const letter = letters[safeIdx % letters.length];
        return {
            mode,
            key: letter,
            labelKey: `verbal_fluency.phonemic.letter`,
        };
    }
    const cat = SEMANTIC_CATEGORIES[safeIdx % SEMANTIC_CATEGORIES.length];
    return { mode, key: cat.key, labelKey: cat.labelKey };
}
/**
 * Normalise un mot : trim + lowercase. Conserve les accents (utile FR).
 * Collapse les espaces internes (un mot composé reste possible).
 */
export function normalizeWord(input) {
    return input.toLowerCase().replace(/\s+/g, ' ').trim();
}
/**
 * Vérifie qu'un mot saisi est valide pour le prompt courant :
 *  - longueur >= 2
 *  - ne contient que lettres (Unicode), espaces, traits d'union, apostrophes
 *  - en mode phonemic : commence par la lettre du prompt (insensible casse)
 *
 * Pas de dictionary lookup MVP : honor system côté user.
 */
export function validateWord(input, prompt, locale) {
    void locale;
    const norm = normalizeWord(input);
    if (norm.length < 2)
        return false;
    // Lettres Unicode + espaces + tiret + apostrophe (curly et droite).
    if (!/^[\p{L}][\p{L}\s\-'’]*$/u.test(norm))
        return false;
    if (prompt.mode === 'phonemic') {
        const first = norm[0].toLowerCase();
        const target = prompt.key.toLowerCase();
        if (first !== target)
            return false;
    }
    return true;
}
/**
 * Déduplique une liste de mots selon leur forme normalisée.
 * Préserve l'ordre d'insertion.
 */
export function dedupeWords(words) {
    const seen = new Set();
    const out = [];
    for (const w of words) {
        const k = normalizeWord(w);
        if (k.length === 0)
            continue;
        if (seen.has(k))
            continue;
        seen.add(k);
        out.push(k);
    }
    return out;
}
//# sourceMappingURL=data.js.map